(() => {
  if (customElements.get('rotating-headline-cta')) return;

  class RotatingHeadlineCta extends HTMLElement {
    connectedCallback() {
      this.words = Array.from(this.querySelectorAll('[data-word]'));
      this.heading = this.closest('.rotating-headline-cta__heading');
      this.index = Math.max(
        0,
        this.words.findIndex((word) => word.classList.contains('is-active'))
      );
      this.interval = Number(this.dataset.interval) || 3000;
      this.animating = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.fitLine = this.fitLine.bind(this);
      this.onSectionUnload = this.onSectionUnload.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);

      this.fitLine();
      window.addEventListener('resize', this.fitLine);

      if (this.heading?.parentElement) {
        this.resizeObserver = new ResizeObserver(() => this.fitLine());
        this.resizeObserver.observe(this.heading.parentElement);
      }

      if (this.words.length >= 2) {
        this.start();
      }

      document.addEventListener('shopify:section:unload', this.onSectionUnload);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener('resize', this.fitLine);
      this.resizeObserver?.disconnect();
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    onSectionUnload(event) {
      if (event.target.contains(this)) this.stop();
    }

    onVisibilityChange() {
      if (document.hidden) {
        this.stop();
      } else if (this.words.length >= 2) {
        this.start();
      }
    }

    fitLine() {
      if (!this.heading) return;

      this.heading.classList.add('is-single-line');

      requestAnimationFrame(() => {
        const overflows = this.heading.scrollWidth > this.heading.clientWidth + 1;
        this.heading.classList.toggle('is-single-line', !overflows);
      });
    }

    start() {
      this.stop();
      if (this.words.length < 2) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      if (this.animating || this.words.length < 2) return;

      const current = this.words[this.index];
      const nextIndex = (this.index + 1) % this.words.length;
      const next = this.words[nextIndex];

      if (this.reducedMotion) {
        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');
        next.classList.add('is-active');
        next.removeAttribute('aria-hidden');
        this.index = nextIndex;
        this.fitLine();
        return;
      }

      this.animating = true;
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      this.fitLine();

      window.setTimeout(() => {
        current.classList.remove('is-leaving');
        current.setAttribute('aria-hidden', 'true');
        this.index = nextIndex;
        this.animating = false;
        this.fitLine();
      }, 450);
    }
  }

  customElements.define('rotating-headline-cta', RotatingHeadlineCta);
})();
